<template lang="pug">
.inherit-switch
  switches(:value="value" @input="v => $emit('input', v)" theme="custom" color="enabled" type-bold="true" :disabled="this.$attrs.disabled")
  BriqIcon.check-icon(name="icon-input-checkbox-icon")
</template>

<script>
import Switches from 'vue-switches'

export default {
  components: { Switches },
  props: {
    value: Boolean,
  },
}
</script>

<style lang="stylus">
.vue-switcher-theme--custom.vue-switcher-color--enabled
  div
    background-color #3e9e00

    &:after
      // for the circle on the switch
      background-color white

  &.vue-switcher--unchecked
    div
      background-color #D3D3D3

      &:after
        background-color white

.inherit-switch
  position relative
  display inline-block

  .icon-input-checkbox-icon
    position absolute
    left 7px
    color white
    top 0
    font-size 11px
</style>
